import React, { useState } from "react";
import { Col, Modal, Row, Form } from "reactstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { addApple2fa, updateApple2fa } from "../../../store/apple2fa/actions";
import { useDispatch } from "react-redux";

const schema = yup.object().shape({
  email: yup.string().max(100).required(),
  password: yup.string().max(100).required(),
  phone: yup.string().max(50).required(),
  sms_url: yup.string().max(255).required(),
  guide_url: yup.string().max(255).required(),
  note: yup.string(),
});

export default function AddNew({
  modal_center,
  tog_center,
  setmodal_center,
  data,
}) {
  const dispatch = useDispatch();
  const isEdit = Object.keys(data).length !== 0;

  const [files, setFiles] = useState(null);
  const [base64Image, setBase64Image] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email: data.email || "",
      password: data.password || "",
      phone: data.phone || "",
      sms_url: data.sms_url || "",
      guide_url: data.guide_url || "",
      note: data.note || "",
      shownote: data.shownote || false,
      state: data.state || false,
    },
  });

  const onSubmit = (formData) => {
    if (isEdit) {
      dispatch(updateApple2fa({ ...formData, id: data.id, image: base64Image }));
    } else {
      dispatch(addApple2fa({ ...formData, image: base64Image }));
    }
    if (!Object.keys(errors).length) {
      setmodal_center(false);
    }
  };

  const imageUploadChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setBase64Image(reader.result);
    };
    reader.readAsDataURL(file);
    setFiles(file);
  };

  return (
    <Modal
      isOpen={modal_center}
      toggle={() => {
        tog_center();
      }}
      centered
    >
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
          style={{ display: "flex", alignItems: "center" }}
        >
          <i className="ri-apple-fill" style={{ paddingRight: 5 }}></i>
          {isEdit ? "Update" : "Add"} Apple 2FA
        </h5>
        <button
          type="button"
          onClick={() => setmodal_center(false)}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-2">
            <Col md="12">
              <label htmlFor="file-input" className="filelabel">
                <input
                  id="file-input"
                  type="file"
                  className="fileinput"
                  onChange={imageUploadChange}
                />
                <img
                  className="logoimg"
                  id="img-preview"
                  alt="logo"
                  src={
                    files
                      ? URL.createObjectURL(files)
                      : data.image
                      ? `https://api.grpiraq.net/public/storage/${data.image}`
                      : `https://api.grpiraq.net/public/storage/logo.png`
                  }
                />
                <p>Click the Image to Upload</p>
              </label>
            </Col>
          </Row>

          <Row className="mb-2">
            <Col md="6">
              <div className="field">
                <input
                  {...register("email")}
                  className={`form-control ${
                    errors.email ? "is-invalid" : null
                  }`}
                  type="email"
                />
                <span className="label">الايميل</span>
              </div>
            </Col>
            <Col md="6">
              <div className="field">
                <input
                  {...register("password")}
                  className={`form-control ${
                    errors.password ? "is-invalid" : null
                  }`}
                  type="text"
                />
                <span className="label">الباسورد</span>
              </div>
            </Col>
          </Row>

          <Row className="mb-2">
            <Col md="12">
              <div className="field">
                <input
                  {...register("phone")}
                  className={`form-control ${
                    errors.phone ? "is-invalid" : null
                  }`}
                  type="text"
                />
                <span className="label">رقم الهاتف</span>
              </div>
            </Col>
          </Row>

          <Row className="mb-2">
            <Col md="12">
              <div className="field">
                <input
                  {...register("sms_url")}
                  className={`form-control ${
                    errors.sms_url ? "is-invalid" : null
                  }`}
                  type="text"
                />
                <span className="label">رابط رقم SMS</span>
              </div>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md="12">
              <div className="field">
                <input
                  {...register("guide_url")}
                  className={`form-control ${
                    errors.guide_url ? "is-invalid" : null
                  }`}
                  type="text"
                />
                <span className="label">رابط الشرح</span>
              </div>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md="12">
              <div className="field mb-3">
                <textarea
                  className={`form-control ${errors.note ? "is-invalid" : null}`}
                  {...register("note")}
                ></textarea>
                <span className="label">Note</span>
              </div>
            </Col>
            <Col md="6">
              <div className="form-check form-switch form-switch-lg mb-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="shownote2fa"
                  {...register("shownote")}
                />
                <label className="form-check-label" htmlFor="shownote2fa">
                  Show Note
                </label>
              </div>
            </Col>
            <Col md="6">
              <div className="form-check form-switch form-switch-lg mb-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="state2fa"
                  {...register("state")}
                />
                <label className="form-check-label" htmlFor="state2fa">
                  Sold
                </label>
              </div>
            </Col>
          </Row>

          <div className="d-flex flex-wrap gap-2 justify-content-center">
            <button
              type="button"
              className="btn btn-lg btn-secondary"
              onClick={() => setmodal_center(false)}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-lg btn-primary">
              {isEdit ? "Update" : "Add New"}
            </button>
          </div>
        </Form>
      </div>
    </Modal>
  );
}
